/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { css } from "styled-components";
import Text from "../ui/Text";
import Icon from "../ui/Icon";
import Stack from "../ui/Stack";
import Flex from "../ui/Flex";

const CheckboxWrapper = styled.label`
  cursor: pointer;
`;

const CheckboxInputWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

const CheckboxInput = styled.input`
  width: 1.25rem;
  height: 1.25rem;
  margin: 0;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
  border-radius: 4px;
  ${({ $checked, theme }) => $checked && css`background: rgba(${theme.colors.border.rgb}, 0.5);`}
  appearance: none;
  cursor: pointer;
`;

const CheckboxIcon = styled(Icon.Check)`
  display: ${({ $checked }) => ($checked ? "block" : "none")};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

const FilterCheckboxGroup = ({ groups = [], selectedFilters = [], onFilterChange }) => {
  const visibleGroups = groups.filter((g) => g.items?.length > 0);
  if (!visibleGroups.length) return null;

  const isChecked = (type, id) => selectedFilters.some((f) => f.type === type && f.id === id);

  return (
    <Stack $gap="0.75rem">
      {visibleGroups.map(({ type, label, items }) => (
        <Stack key={type} $gap="0.5rem">
          <Text weight="bold">{label}</Text>
          <Stack $gap="0.5rem">
            {items.map(({ id, name }) => {
              const checked = isChecked(type, id);
              return (
                <CheckboxWrapper key={id}>
                  <Flex $align="center" $gap="0.5rem">
                    <CheckboxInputWrapper>
                      <CheckboxInput
                        type="checkbox"
                        $checked={checked}
                        checked={checked}
                        onChange={() => onFilterChange(type, id)}
                      />
                      <CheckboxIcon $checked={checked} size={Icon.SIZE.SM} />
                    </CheckboxInputWrapper>
                    <Text color="dark">{name}</Text>
                  </Flex>
                </CheckboxWrapper>
              );
            })}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};

export default FilterCheckboxGroup;